import { JsonProperty } from "ts-serializer-core";


export class AtpOwnerSerializer {

  @JsonProperty('email')
  public email?: string;

  @JsonProperty('first_name')
  public first_name?: string;

  @JsonProperty('last_name')
  public last_name?: string;

  @JsonProperty('middle_name')
  public middle_name?: string;

  @JsonProperty('office_phone')
  public office_phone?: string;

  @JsonProperty('phone')
  public phone?: string;

  @JsonProperty('second_phone')
  public second_phone?: string;
}

export class DriverRequestAtpSettingsSerializer {

  @JsonProperty('is_level_1')
  public is_level_1?: boolean;

  @JsonProperty('is_need_drivers')
  public is_need_drivers?: boolean;
}

export class AtpSerializer {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('name')
  public name?: string;

  @JsonProperty('owner')
  public owner?: AtpOwnerSerializer;

  @JsonProperty('replacement_time')
  public replacement_time?: string;

  @JsonProperty('driver_request_settings')
  public driver_request_settings?: DriverRequestAtpSettingsSerializer
}